var Window = {
  getComputedStyle: function (node) {
    return {
      getPropertyValue: node.style.getProperty
    }
  }
}

module.exports = Window



//////////////////
// WEBPACK FOOTER
// ./~/react-faux-dom/lib/Window.js
// module id = 1039
// module chunks = 0